<template>
  <div class="row bg-red" id="header">
    <div class="col-4">
      <a :href="cellyieldUrl">
        <img :src="image" class="img-fluid" id="header" alt="3s-logo" />
      </a>
    </div>

    <div class="col-4 p-3 px-0 align-self-md-center text-center" id="header">
      <h2 class="mb-0 text-white">{{ props.stationName }}</h2>
    </div>

    <div class="col-4 d-flex justify-content-end align-items-center pe-4">
      <button @click="handleLogout" class="btn btn-light fw-bold text-danger">
        Logout
      </button>
    </div>
  </div>
</template>

<script setup>
import image from "@/assets/icon_logo.png";
import { env } from "@/config/env";
import { defineProps } from "vue";

const props = defineProps({
  stationName: {
    type: String,
    required: true,
  },
});

const cellyieldUrl = env.MES_THUN_URL;

async function handleLogout() {
  const token = localStorage.getItem("token");
  const apiBase = env.API_BASE_URL;

  if (!token) {
    window.location.href = "https://login.microsoftonline.com/logout";
    return;
  }

  try {
    const res = await fetch(`${apiBase}/auth/logout`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const { logoutUrl } = await res.json();

    localStorage.removeItem("token");
    window.location.href = logoutUrl;
  } catch (err) {
    console.error("Logout error", err);
    window.location.href = "https://login.microsoftonline.com/logout";
  }
}
</script>

<style>
#header {
  max-height: 5em;
}
.bg-red {
  background-color: #b91c1c; /* Set the desired background color */
}
</style>
